export default [
  {
    icon: "GridIcon",
    title: "Home",
    route: "foravila-home",
  },
];
